/* eslint-disable max-len */
import { INTL_IDS } from './messages';

export const CHANGE_INPUT = 'app/Register/ForgotPassword/CHANGE_INPUT';
export const CHANGE_INPUT_ERROR = 'app/Register/ForgotPassword/CHANGE_INPUT_ERROR';

export const CHANGE_STEP = 'app/Register/ForgotPassword/CHANGE_STEP';

export const FORGOT_PASSWORD_INITIATE = 'app/Register/ForgotPassword/FORGOT_PASSWORD_INITIATE';
export const FORGOT_PASSWORD_INITIATE_FAILURE = 'app/Register/ForgotPassword/FORGOT_PASSWORD_INITIATE_FAILURE';
export const FORGOT_PASSWORD_INITIATE_SUCCESS = 'app/Register/ForgotPassword/FORGOT_PASSWORD_INITIATE_SUCCESS';

export const FORGOT_PASSWORD_VERIFY = 'app/Register/ForgotPassword/FORGOT_PASSWORD_VERIFY';
export const FORGOT_PASSWORD_VERIFY_FAILURE = 'app/Register/ForgotPassword/FORGOT_PASSWORD_VERIFY_FAILURE';
export const FORGOT_PASSWORD_VERIFY_SUCCESS = 'app/Register/ForgotPassword/FORGOT_PASSWORD_VERIFY_SUCCESS';

export const RESET_INPUT_ERRORS = 'app/Register/ForgotPassword/RESET_INPUT_ERRORS';
export const RESET_STATE = 'app/Register/ForgotPassword/RESET_STATE';

// Messages
export const FORGOT_PASSWORD_ERROR_MESSAGE = INTL_IDS.FORGOT_PASSWORD_ERROR_GENERIC_MESSAGE;

export const FORGOT_PASSWORD_CONFIRMATION_DICTIONARY = {
  bannerError: {
    header: INTL_IDS.FORGOT_PASSWORD_BANNER_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_BANNER_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  forgotPasswordInitiateError: {
    header: INTL_IDS.FORGOT_PASSWORD_INITIATE_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_INITIATE_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  forgotPasswordInitiateSuccess: {
    header: INTL_IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_HEADING,
    isSuccess: true,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
    needsFormatting: true,
    text: INTL_IDS.FORGOT_PASSWORD_INITIATE_SUCCESS_PARAGRAPH,
  },
  forgotPasswordVerifyError: {
    header: INTL_IDS.FORGOT_PASSWORD_VERIFY_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_VERIFY_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  forgotPasswordVerifySuccess: {
    header: INTL_IDS.FORGOT_PASSWORD_VERIFY_SUCCESS_HEADING,
    isSuccess: true,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_VERIFY_SUCCESS_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
  serviceError: {
    header: INTL_IDS.FORGOT_PASSWORD_SERVICE_ERROR_HEADING,
    isSuccess: false,
    link: {
      label: INTL_IDS.FORGOT_PASSWORD_SERVICE_ERROR_LINK_LABEL,
      path: { desktop: '/login', mobile: 'Login' },
    },
  },
};

export const DEFAULT_FORGOT_PASSWORD_ERRORS = {
  defaultForgotPasswordErrors: {
    bannerError: [],
    loanNumber: '',
    noError: '',
    ssnTin: '',
    username: '',
    zipCode: '',
  },
  defaultResetPasswordErrors: {
    bannerError: [],
    confirmEmail: '',
    email: '',
    noError: '',
  },
};

export const VIEW_NAMESPACE_DICTIONARY = {
  init: {
    1: 'forgotPassword',
    2: '',
  },
  verify: {
    1: 'resetPassword',
    2: '',
  },
};
